import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  InputAdornment,
  TextField,
  withStyles
} from '@material-ui/core';
import React, { useCallback, useMemo } from 'react';
import flowRight from 'lodash.flowright';
import clsx from 'clsx';
import { connect } from 'react-redux';
import withSettings from '../../../utils/withSettings';
import styles, { customSelectStyles, customStyles } from '../styles/filters';
import Select from 'react-select';

import { reactSelectDefaultStyles } from '../../../consts/reactSelectDefaultStyles';
import {
  BILLING_STATUS_OPTIONS,
  SUBSCRIPTIONS_STATUS_OPTIONS
} from '../../../consts/initialValues';
import { actions as reduxActions } from '../reducers';
import { translate } from '../../../i18n/I18nProvider';
import { countFilters } from '../actions/customSearchActions';
import { Search } from '@material-ui/icons';
import GroupBy from './GroupBy';
import { isDefined } from '../../../utils/isDefined';

const Filters = ({
  settings,
  classes,
  filters,
  updateFilters,
  productOptions,
  selectedAccount,
  selectOptions
}) => {
  const handleSelectChange = useCallback(
    (selected, key) => {
      updateFilters({ key, value: selected });
    },
    [updateFilters]
  );

  const handleChange = useCallback(
    (event, key) => {
      updateFilters({ value: event.target.value, key });
    },
    [updateFilters]
  );

  const accountsOptions = useMemo(
    () =>
      selectOptions.map(option => ({
        value: option.value,
        ...option,
        label: option.filterLabel
      })),
    [selectOptions]
  );

  return (
    <Accordion className={classes.accordion}>
      <AccordionSummary
        classes={{ content: classes.accordionSummary }}
        expandIcon={
          <i className={clsx('fa fa-angle-down', classes.showMoreIcon)} />
        }
      >
        <i
          className={clsx('fad fa-filter', classes.accordionIcon)}
          style={{
            color: settings.colors.dashboard_icon
          }}
        ></i>
        <div>{`Filters (${countFilters(filters)})`}</div>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.accordionDetailsRoot }}>
        <div className={classes.row}>
          <div className={classes.container}>
            {translate('BUTTON.SEARCH')}
            <TextField
              variant="outlined"
              margin="dense"
              fullWidth
              onChange={e => handleChange(e, 'search')}
              value={filters.search}
              style={customStyles.textfieldRoot}
              className={classes.searchField}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {isDefined(filters.search) && filters.search.length > 0 && (
                      <i
                        className={clsx('fas fa-times', classes.closeIcon)}
                        onClick={() =>
                          handleChange({ target: { value: '' } }, 'search')
                        }
                      ></i>
                    )}
                  </InputAdornment>
                )
              }}
              inputProps={{ autoComplete: 'off', 'data-lpignore': true }}
            />
          </div>
          <div className={classes.container} style={{ paddingRight: '10px' }}>
            {translate('STATUS')}
            <Select
              customStyles={customSelectStyles}
              styles={reactSelectDefaultStyles}
              value={filters.status}
              onChange={selected => handleSelectChange(selected, 'status')}
              options={SUBSCRIPTIONS_STATUS_OPTIONS}
              isSearchable={true}
              isMulti
            />
          </div>
          <div className={classes.container}>
            {translate('BILLING_STATUS')}
            <Select
              customStyles={customSelectStyles}
              styles={reactSelectDefaultStyles}
              value={filters.billingStatus}
              onChange={selected =>
                handleSelectChange(selected, 'billingStatus')
              }
              options={BILLING_STATUS_OPTIONS}
              isSearchable={true}
              isMulti
            />
          </div>
        </div>
        <div className={classes.row}>
          <div className={classes.container} style={{ paddingRight: '10px' }}>
            {translate('PRODUCT')}
            <Select
              customStyles={customSelectStyles}
              styles={reactSelectDefaultStyles}
              value={filters.product}
              onChange={selected => handleSelectChange(selected, 'product')}
              options={productOptions}
              isSearchable={true}
              isMulti
              closeMenuOnSelect={false}
            />
          </div>
          {selectedAccount?.type === 'CUSTOMER' && (
            <div className={classes.container}>
              {translate('ACCOUNT')}
              <Select
                customStyles={customSelectStyles}
                styles={reactSelectDefaultStyles}
                value={filters.account}
                onChange={selected => handleSelectChange(selected, 'account')}
                options={accountsOptions}
                isSearchable={true}
                isMulti
                closeMenuOnSelect={false}
              />
            </div>
          )}
        </div>
        <div className={classes.row}>
          <div className={classes.container}>
            {translate('SUBSCRIPTIONS.GROUP_BY')}
            <GroupBy />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const mapStatesToProps = ({ subscriptionsImproved, auth }) => {
  return {
    filters: subscriptionsImproved.filters,
    productOptions: subscriptionsImproved.productOptions,
    selectedAccount: subscriptionsImproved.selectedAccount,
    selectOptions: subscriptionsImproved.selectOptions,
    lang: auth.lang
  };
};

const mapDispatchToProps = {
  updateFilters: reduxActions.updateFilters
};

export default flowRight(
  withSettings,
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(Filters);
